import { ref, inject, reactive,nextTick } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { Toast } from 'vant'

/*
  当前页面form表单提交post数据，跳转lipapay收银台
  禁止iframe。safari安全策略问题。
*/
const open = (verb: string, url: string, data: object) => {
    var form = document.createElement("form");
    form.action = url;
    form.method = verb;
    form.target = "_self";
    if (data) {
      for (var key in data) {
        var input = document.createElement("input");
        input.name = key;
        input.value = typeof data[key] === "object" ? JSON.stringify(data[key]) : data[key];
        form.appendChild(input);
      }
    }
    form.style.display = 'none';
    document.body.appendChild(form);

    form.submit();
}; 
/**
 * 收银台支付
 */
const GetPayFn = async ($http: any, pay_sn: any, submit_loading: any = null) => {
    let paream = {
        pay_sn: pay_sn,
        method: 'OL',
        source: 3
    }
    let ret = await $http.get_pay(paream)
    if(ret.code === 200){            
        open('post', ret.data.url, ret.data.post_data)
    }
    else {               
      Toast.fail(ret.message);
      if(submit_loading) submit_loading.value = false;
    }
};
 
export {
  GetPayFn
}

